import type { UUID } from '@cobliteam/common-types';

import { CookieManager } from '@cobliteam/cookie-manager';
import { DatadogTrack } from '@cobliteam/datadog-rum';
import { Environment } from '@cobliteam/react-environments';

declare const analytics: any; // Segment global variable initialized on index.html

let hasBeenInitialized = false;
let currentPageTitle = '';

interface Properties {
  [key: string]: any;
}

export class Analytics {
  public static initialize = () => {
    if (hasBeenInitialized) {
      console.warn('Analytics has already been initialized');
      return;
    }

    const env = Environment.getInstance().getEnvironment();

    analytics.load(env.segmentAnalyticsKey);

    hasBeenInitialized = true;
  };

  public static getCurrentPageTitle = () => currentPageTitle;

  public static setUser = (userId: UUID, userName: string, email: string, userRole: string, fleetId: UUID, fleetName: string) => {
    analytics.identify(userId, {
      name: userName,
      role: userRole,
      fleet: fleetName,
      fleetId,
      email,
    });

    const fleetNameLettersAndNumbersOnly = fleetName.toLowerCase().replace(/[^a-zA-Z0-9]+/g, '');
    analytics.group(fleetId, {
      name: fleetName,
      fleetId,
      website: `https://www.${fleetNameLettersAndNumbersOnly}.com`,
    });
  };

  public static track = (eventName: string, props?: Properties, debug?: boolean) => {
    const isLocalhost = window.location.href.includes('localhost');
    const isPreview = window.location.href.includes('dashboard.preview.cobli.co');

    const enabled = debug ? true : !(isLocalhost || isPreview);

    if (enabled) {
      const fleetId = analytics?.group().id ? analytics.group().id() : undefined;
      const hubspotUtk = CookieManager.getCookie('hubspotutk');

      analytics.track(eventName, { ...props, fleetId, hubspotUtk });
      DatadogTrack.action(eventName);
    }
  };

  public static pageview = (pageTitle: string) => {
    const isLocalhost = window.location.href.includes('localhost');
    const isPreview = window.location.href.includes('dashboard.preview.cobli.co');

    currentPageTitle = pageTitle;

    if (!isLocalhost && !isPreview) {
      const fleetId = analytics?.group().id ? analytics.group().id() : undefined;

      analytics.page(pageTitle, {
        url: window.location.href,
        path: window.location.pathname,
        search: window.location.search,
        referrer: location.origin,
        fleetId,
      });
    }
  };
}
